<div class="drop-down-sort-options me-4">
  <mat-label class="sort-options-label me-3">Sort Options:</mat-label>
  <mat-form-field appearance="outline" class="form-field">


    <mat-select [(value)]="selectedSortOption" (selectionChange)="onSortOptionChange($event.value)">


      <mat-select-trigger>
        <span class="select-order me-4">{{ selectedSortOrder }}</span>   
        <span class="select-option">{{ selectedSortOption }}</span>
      </mat-select-trigger>

      <div>
      <mat-option disabled>
        <mat-label class="sort-label">Sort Order :</mat-label>
      </mat-option>  
      
      <mat-option disabled>
        <div class="sort-toggle-wrapper d-flex">
          <button [disabled]="!isFilterdJobListAvailable" mat-button class="sort-toggle-btn" [ngClass]="{ 'active': selectedSortOrder === 'Ascending' }"
            (click)="onSortOrderChange('Ascending'); $event.stopPropagation()">
            Ascending
            <span class="material-symbols-outlined fs-2">arrow_upward_alt</span>
          </button>
          <button [disabled]="!isFilterdJobListAvailable" mat-button class="sort-toggle-btn" [ngClass]="{ 'active': selectedSortOrder === 'Descending' }"
            (click)="onSortOrderChange('Descending'); $event.stopPropagation()">
            Descending
            <span class="material-symbols-outlined fs-2">arrow_downward_alt</span>
          </button>
        </div>
      </mat-option>


     <mat-option disabled>
        <mat-label class="sort-label" >Sort By :</mat-label>
      </mat-option>
      <mat-option [disabled]="!isFilterdJobListAvailable" *ngFor="let option of sortOptions" [value]="option">
        <mat-icon class="me-2">
          {{ selectedSortOption === option ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </mat-icon>
        {{ option }}
      </mat-option>
      </div>

    </mat-select>
  </mat-form-field>
</div>

